<template>
  <div>
    <div class="edit-notification" @click="onEditNotificationDialog">
      <div class="edit-notification-icon" ></div>
    </div>
    <el-dialog
      title
      class="edit-notification-dialog"
      :visible.sync="dialogVisible"
      width="760px"
      top="8vh"
    >
      <div class="title">{{searchText}} 告警设置</div>
      <div class="select-title">负面舆情告警</div>
      <div class="switch">
        <span class="close" :class="{isClose: status===false}">关</span>
        <el-switch v-model="status" :class="{'el-switch-core':status===false }"></el-switch>
        <span class="open" :class="{isOpen: status===true}">开</span>
      </div>
      <div class="status-true" v-show="status===true">
        <div>
          <div class="warning-category-title-icon"></div>
          <div class="warning-category-title">告警类别</div>
        </div>
        <div  v-loading="isLoading">
          <alarm-category
            :filters="filters"
            :name="searchText"
            @change="onCategoriesChange"
          ></alarm-category>
        </div>
      <div>
          <div class="warning-index-icon"></div>
          <div class="warning-index">告警阈值</div>
        </div>
        <threshold-alarm-setting :radio-data="threshold.type" :option-data="threshold.value.key" :input-data="threshold.value.val" @radioChange="radioChange" @optionChange="optionChange" @inputChange="inputChange"></threshold-alarm-setting>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button class="cancel-btn" @click="dialogVisible = false">取 消</el-button>
        <el-button class="confirm-btn" @click="onOKBtnClick" :loading="alarmOkBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import AlarmCategory from '@/components/news-monitor/AlarmCategory';
import ThresholdAlarmSetting from '@/components/common/ThresholdAlarmSetting';
import QuestionQuery from '@/rest/questionQuery';

export default {
  data() {
    return {
      alarmOkBtn: false,
      threshold: {
        type: 'automatic',
        value: {
          key: 'index',
          val: 10
        }
      },
      categories: [],
      isLoading: false,
      dialogVisible: false,
      status: false,
      filters: {
        negative: []
      },
      type: 'automatic',
      key: 'index',
      val: 10,
      newsListFilters: []
    };
  },
  props: {
    searchText: {
      type: String
    }
  },
  components: {
    AlarmCategory,
    ThresholdAlarmSetting
  },
  methods: {
    onEditNotificationDialog() {
      this.dialogVisible = true;
      QuestionQuery.getEntityAlarmSetting(this.searchText).then(res => {
        this.filters.negative = res.categories;
        if (res.status === 'on') {
          this.status = true;
        } else {
          this.status = false;
        }
        this.threshold = res.threshold;
      });
    },
    radioChange(res) {
      this.threshold.type = res;
    },
    optionChange(res) {
      this.threshold.value.key = res;
    },
    inputChange(res) {
      this.threshold.value.val = res;
    },
    onCategoriesChange(filters) {
      this.categories = filters;
    },
    onOKBtnClick() {
      const params = {
        name: this.searchText,
        status: this.status ? 'on' : 'off',
        categories: this.categories,
        threshold: this.threshold
      };
      if (!this.categories.length) {
        this.$message.error('请选择告警类别');
      } else if (this.threshold.type === 'custom' && !this.threshold.value.key) {
        this.$message.error('请选择阈值类型');
      } else if (this.threshold.type === 'custom' && !this.threshold.value.val) {
        this.$message.error('阈值要求大于0');
      } else {
        this.alarmOkBtn = true;
        QuestionQuery.setEntityAlarmSetting(params).then(() => {
          this.alarmOkBtn = false;
          this.dialogVisible = false;
          this.$emit('entityAlarmStatus', this.status);
        });
      }
    }
  },
  watch: {
    status() {
      this.$emit('entityAlarmStatus', this.status);
    }
  },
  mounted() {
    QuestionQuery.getEntityAlarmSetting(this.searchText).then(res => {
      this.filters.negative = res.categories;
      this.categories = res.categories;
      if (res.status === 'on') {
        this.status = true;
      } else {
        this.status = false;
      }
      this.threshold = res.threshold;
      this.$emit('entityAlarmStatus', this.status);
    });
  }
};
</script>

<style lang="scss" scoped>
.edit-notification {
  display: inline-block;
  width: 28px;
  height: 28px;
  cursor: pointer;
  .edit-notification-icon {
    display: inline-block;
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
}
/deep/ .el-dialog {
  border-radius: 8px;
  background-color: #333138;
  .el-dialog__header {
    padding: 0;
  }
}
.title {
  padding-bottom: 24px;
  color: #ffffff;
  font-size: 20px;
}
.select-title {
  display: inline-block;
  margin-right: 72px;
  padding-bottom: 24px;
  color: #ffffff;
  font-size: 18px;
}
.switch {
  display: inline-block;
  .close {
    margin-right: 8px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
  }
  .isClose {
    color: #45a8cc;
  }
  .open {
    margin-left: 8px;
    font-size: 14px;
    color: rgba(255, 255, 255, 0.6);
  }
  .isOpen {
    color: #45a8cc;
  }
}
.warning-category-title-icon {
  display: inline-block;
  margin-right:4px;
  margin-bottom: 5px;
  width: 18px;
  height: 18px;
  vertical-align: middle;
  background-image: url("../../assets/img/exclamation-point.svg");
  background-size: cover;
}
.warning-category-title {
  display: inline-block;
  font-size: 18px;
  color: #ffffff;
}
.warning-index-icon {
  display: inline-block;
  margin-right:4px;
  margin-bottom: 7px;
  width: 16px;
  height: 18px;
  vertical-align: middle;
  background-image: url("../../assets/img/warning.svg");
  background-size: cover;
}
.warning-index {
  display: inline-block;
  padding-top: 26px;
  padding-bottom: 16px;
  font-size: 18px;
  color: #ffffff;
}
.cancel-btn {
  height: 48px;
  width: 99px;
  padding: 0;
  font-size: 16px;
  color: #ffffff;
  background-color: #3b3a3f;
  border-radius: 2px;
  border: none;
  &:hover {
    color: #ffffff;
    background-color: #423f43;
  }
  &:focus {
    color: #ffffff;
    background-color: #423f43;
  }
  &:active {
    color: #ffffff;
    background-color: #38363c;
  }
}
.confirm-btn {
  height: 48px;
  width: 99px;
  padding: 0;
  font-size: 16px;
  color: #ffffff;
  background-color: #45a8cc;
  box-shadow: 0px 2px 4px 0px rgba(6, 94, 114, 0.1);
  border-radius: 2px;
  border: none;
  &:hover {
    color: #ffffff;
    background-color: #3cbeed;
  }
  &:focus {
    color: #ffffff;
    background-color: #3cbeed;
  }
  &:active {
    color: #ffffff;
    background-color: #368cab;
  }
}
.el-switch-core /deep/.el-switch__core{
  border:1px solid transparent;
  background-color: #646367;
}
</style>

